import axios from 'axios';

// ข้อมูลตั้งต้นของหน้าแรก/หน้าบริการ: API /contents/customer-index ยังคืนค่าว่างทุกช่อง
// ทำให้หน้าเว็บไม่มีข้อความและรูป ถ้ากรอกข้อมูลในระบบหลังบ้านแล้ว ค่าจาก API จะถูกใช้แทน
const DEFAULT_CUSTOMER_INDEX = {
    section1: {
        topic: 'ทำไมต้องมูฟไว',
        description1: 'ขนส่งสินค้ามีค่าโดยทีมงานมืออาชีพ พร้อมรับประกันสินค้าเต็มจำนวน 100%',
        description2: 'มีสาขาครอบคลุมทั่วประเทศ และเช็คสถานะสินค้าได้ตลอดการจัดส่ง',
        image1: '/images/main_2.jpg',
        image2: '/images/main_1.jpg',
        youtube: ''
    },
    section2: {
        channel1: {
            content: 'บริการขนส่งสินค้ามีค่าผ่านทาง บริษัท มูฟไว จำกัด แบบส่งสินค้าภายในวัน มีการรับประกันสินค้าสูญหาย 100% ซึ่งจัดส่งในรูปแบบแมสเซ็นเจอร์ของบริษัท',
            fullContent: 'บริการขนส่งสินค้ามีค่าผ่านทาง บริษัท มูฟไว จำกัด แบบส่งสินค้าภายในวัน มีการรับประกันสินค้าสูญหาย 100% ซึ่งจัดส่งในรูปแบบแมสเซ็นเจอร์ของบริษัท',
            image: '/images/move-sameday.jpg'
        },
        channel2: {
            content: 'บริการขนส่งสินค้ามีค่าผ่านทาง บริษัท มูฟไว จำกัด ที่มีการรับประกันสินค้าสูญหาย 100% ซึ่งจัดส่งในรูปแบบด่วนพิเศษ',
            fullContent: 'บริการขนส่งสินค้ามีค่าผ่านทาง บริษัท มูฟไว จำกัด ที่มีการรับประกันสินค้าสูญหาย 100% ซึ่งจัดส่งในรูปแบบด่วนพิเศษ',
            image: '/images/move-express.jpg'
        },
        channel3: {
            content: 'บริการจัดส่งสินค้ามีค่า ผ่านทาง บริษัท มูฟไว จำกัด ที่มีการรับประกันสินค้าสูญหาย 100%',
            fullContent: 'บริการจัดส่งสินค้ามีค่า ผ่านทาง บริษัท มูฟไว จำกัด ที่มีการรับประกันสินค้าสูญหาย 100%',
            image: '/images/move-transit.jpg'
        }
    }
};

// ข้อมูลตั้งต้นของหน้าเกี่ยวกับเรา: API /contents/about-us ยังคืน group ว่างทั้งหมด
const DEFAULT_ABOUT_US = {
    group1: {
        text: 'บริษัท มูฟไว จำกัด ให้บริการขนส่งสินค้ามีค่าโดยทีมงานมืออาชีพ ทั้งแบบส่งภายในวัน ด่วนพิเศษ และขนส่งระหว่างจังหวัด พร้อมรับประกันสินค้าเต็มจำนวน เพื่อให้ลูกค้ามั่นใจได้ทุกการจัดส่ง',
        image: '/images/about_cover.jpg'
    },
    group2: {
        text: 'เป็นผู้นำด้านการขนส่งสินค้ามีค่าที่ลูกค้าไว้วางใจ ด้วยความปลอดภัย ความรวดเร็ว และความถูกต้องในทุกการจัดส่ง',
        image: '/images/about_1.jpg'
    },
    group3: {
        text: 'ส่งมอบสินค้าถึงมือผู้รับอย่างปลอดภัยและตรงเวลา รับประกันสินค้าสูญหาย 100% และพัฒนาบริการให้ลูกค้าติดตามสถานะสินค้าได้ตลอดการจัดส่ง',
        image: '/images/about_2.jpg'
    }
};

const isObject = value => value !== null && typeof value === 'object' && !Array.isArray(value);

// ใช้ค่าจาก API เฉพาะช่องที่มีข้อมูล ช่องว่างใช้ค่าตั้งต้นแทน
function mergeFilled(defaults, data) {
    if (!isObject(data)) return defaults;
    const result = { ...defaults };
    for (const key of Object.keys(data)) {
        const value = data[key];
        if (isObject(defaults[key])) {
            result[key] = mergeFilled(defaults[key], value);
        } else if (value !== '' && value !== null && value !== undefined) {
            result[key] = value;
        }
    }
    return result;
}

async function getContent(path, defaults) {
    try {
        const response = await axios.get(process.env.VUE_APP_BASE_URL + path);
        return mergeFilled(defaults, response.data);
    } catch (error) {
        return mergeFilled(defaults, {});
    }
}

export function defaultCustomerIndex() {
    return mergeFilled(DEFAULT_CUSTOMER_INDEX, {});
}

export function getCustomerIndex() {
    return getContent('/contents/customer-index', DEFAULT_CUSTOMER_INDEX);
}

export function defaultAboutUs() {
    return mergeFilled(DEFAULT_ABOUT_US, {});
}

export function getAboutUs() {
    return getContent('/contents/about-us', DEFAULT_ABOUT_US);
}
